import React, { useContext } from "react";

import { Panel } from "@atlaskit/navigation-system";
import { xcss, Inline } from "@atlaskit/primitives-next";

import { PagePanelContext } from "@/common/contexts";

const panelWrapperStyle = xcss({
    paddingBlock: "space.400",
    paddingInline: "space.400"
});

export const PagePanel: React.FC = () => {
    const { isPanelOpen, panelContent } = useContext(PagePanelContext);

    return (
        isPanelOpen && (
            <Panel defaultWidth={400} hasBorder={true}>
                <Inline xcss={panelWrapperStyle} grow="fill">
                    {panelContent}
                </Inline>
            </Panel>
        )
    );
};
